import { makeAutoObservable, observable, reaction } from 'mobx';

import {
  TConstraints,
  TConstraintsFilter,
  TConstraintsSort,
  TPageable,
} from 'app/common/constraints/core/constraints';
import { INotifications } from 'app/common/notifications/core/notifications';
import { HttpRequest, IHttpClient } from 'app/libs/http-client/types';
import { ObservableRequest } from 'app/libs/observable-request';

import { EntityGridConstraints } from '../modules/entity-grid-constraints';

type ListEntityResourceParams<
  Sort extends TConstraintsSort<any>,
  Filter extends TConstraintsFilter<any>,
> = {
  apiClient: IHttpClient;
  httpRequest: (constraints?: TConstraints<Sort, Filter>) => HttpRequest;
  notify: INotifications;
  constraints: EntityGridConstraints;
};

export class ListEntityResource<
  Done,
  Sort extends TConstraintsSort<any>,
  Filter extends TConstraintsFilter<any>,
> {
  public data: TPageable<Done[]> = {
    content: [],
    page: 1,
    size: 40,
    totalElements: 40,
    totalPages: 1,
  };

  private request: ObservableRequest<
    TConstraints<Sort, Filter>,
    TPageable<Done[]>
  >;

  public get isLoading() {
    return this.request.isLoading;
  }

  public constraints: EntityGridConstraints;

  constructor({
    apiClient,
    httpRequest,
    notify,
    constraints,
  }: ListEntityResourceParams<Sort, Filter>) {
    this.constraints = constraints;

    const request = (constraints?: TConstraints<Sort, Filter>) =>
      apiClient.fetch<TPageable<Done[]>>(httpRequest(constraints));

    this.request = new ObservableRequest(request, {
      done: (dataList) => this.setData(dataList),
      fail: (error) =>
        notify.addMessage({ type: 'error', message: error.message }),
    });

    makeAutoObservable(this, { data: observable.shallow });
  }

  private constraintsUpdated = reaction(
    () => [
      this.constraints.data.sorting,
      this.constraints.data.filter,
      this.constraints.data.pageInfo.page,
      this.constraints.data.pageInfo.size,
    ],
    () => {
      this.read();
    },
  );

  public dispose() {
    this.constraintsUpdated();
  }

  private setData(respData: TPageable<Done[]>) {
    this.data = respData;
    this.constraints.updatePageInfo({
      page: respData.page,
      size: respData.size,
    });
  }

  public read() {
    const constraints = this.constraints.data;

    this.request.fetch(constraints as any);
  }

  // public filterRecords(filters: Filter) {
  //   this.constraints.setFilters(filters);

  //   this.read();
  // }

  // public changeConstraints({ pagination, sort }: ChangableConstraints<Sort>) {
  //   this.constraints.updatePageInfo({
  //     page: pagination.current,
  //     size: pagination.pageSize,
  //   });

  //   this.constraints.updateSort(sort);

  //   this.read();
  // }
}

// Example
// type Sortttt = TConstraintsSort<{ bob: string }>;
// type Filtttt = TConstraintsFilter<{ id: number }>;

// const resource = new ListResource<TBankCard, Sortttt, {}>({
//   apiClient: apiClient,
//   constraints: new ConstraintsStore(),
//   httpRequest: (constraints) =>
//     createRequest({ method: 'get', url: '', body: JSON.stringify(constraints) }),
//   notify: new NotificationsStore(),
// });
